import _ from 'lodash';
import Vue from 'vue';

export default {
    eventBus: null,
    windowResizeEventHandler: null,
    init({ mock } = {}) {
        if (mock) {
            _.assign(this, mock);
            return;
        }

        if (!this.eventBus) {
            this.eventBus = new Vue();
            this.createThrottledResizeHandler();
            window.addEventListener('resize', this.windowResizeEventHandler);
        }
    },
    createThrottledResizeHandler() {
        this.init();

        this.windowResizeEventHandler = _.debounce(() => {
            this.eventBus.$emit('screenSizeChanged');
        }, 300);
    },
};
